import React,{useState} from 'react'
import './DetailWholeSaleComp.css';
import {Grid} from '@mui/material'
const DetailWholeSaleComp = () => {

    const [windowWidth, setWindowWidth] = useState(window.outerWidth);

    window.addEventListener('resize',function (){
      setWindowWidth(window.outerWidth)
    })


  return (
    <div className='DetailWholeSaleCompMain'>
        <p style={{fontWeight:700,fontSize:22,textAlign:'left',marginTop:30}}>Whole Sale Rate (Complete Package)</p>
        <Grid container>
        <Grid item md={4} sm={6} xs={10}>
            <hr className='wholeSaleHr' />
            <div className='DetailsWholeSaleSubDiv'>
                <span className='detailsWholeSaleHours'>3 Hours</span>
                <span className='detailsWholeSalePrice'>$ 1,050</span>
            </div>
            <hr className='wholeSaleHr' />
            <div className='DetailsWholeSaleSubDiv'>
                <span className='detailsWholeSaleHours'>4 Hours</span>
                <span className='detailsWholeSalePrice'>$ 1,400</span>
            </div>
            <hr className='wholeSaleHr' />
            <div className='DetailsWholeSaleSubDiv'>
                <span className='detailsWholeSaleHours'>6 Hours</span>
                <span className='detailsWholeSalePrice'>$ 2,100</span>
            </div>
            <hr className='wholeSaleHr' />
            <div className='DetailsWholeSaleSubDiv'>
                <span className='detailsWholeSaleHours'>8 Hours</span>
                <span className='detailsWholeSalePrice'>$ 2,800</span>
            </div>

            <hr className='wholeSaleHr' />

            <div className='DetailsWholeSaleSubDiv'>
            <span>Fuel is included</span>
            </div>

            <hr className='wholeSaleHr' />

        </Grid>
        </Grid>
    </div>
  )
}

export default DetailWholeSaleComp